import React from 'react';
import {
    makeStyles,
    withStyles,
} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const LeadsImportTable = ({ leads, handleDelete, handleStartSMS }) => {
    if (!leads || leads.length === 0) {
        return null;
    }

    const classes = useStyles();

    return (
        <Box>
            <Box mt={3}>
                <Typography variant='h6'>Import Results</Typography>
            </Box>
            <Box mt={1} mb={2}>
                <Button variant="contained" color="primary" onClick={handleStartSMS}>Send SMS to all Leads</Button>
            </Box>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Phone Number</TableCell>
                            <TableCell>Wedding Date</TableCell>
                            <TableCell>Venue</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {leads.map(x => {
                            return (
                                <StyledTableRow key={`lead-${x.id}`}>
                                    <TableCell component="th" scope="row">
                                        <a href={`/admin/couples/${x.id}`} target='_blank'>{x.bride_full_name} and {x.groom_full_name}</a>
                                    </TableCell>
                                    <TableCell>{x.bride_email}</TableCell>
                                    <TableCell>{x.couple_cell}</TableCell>
                                    <TableCell>{x.wedding_date_formatted} {x.wedding_time_formatted}</TableCell>
                                    <TableCell>{x.venue}</TableCell>
                                    <TableCell><IconButton color='inherit' onClick={() => handleDelete(x)}><DeleteIcon /></IconButton></TableCell>
                                </StyledTableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
};

export default LeadsImportTable;